// extracted by mini-css-extract-plugin
export default {"link":"aVy1GX","aside":"W8ZXd0","title":"RySNRE","list":"A1U5TY","listItem":"DME2l1","listContainer":"uGt6nZ","background":"HY_9XW","fadeIn":"w96V2g","expand":"DI4TPu"};